import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: { main: "#A0AF91" },
        secondary: { main: "#FFE876" },
    },
    typography: {
        fontFamily: 'Poppins, Roboto, Arial',
        fontSize: 12, // Adjust this to your preferred size
    },
});

export default theme;